import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "native-auth" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = {
  key: 1,
  class: "info"
}
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = {
  key: 0,
  class: "admin-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_NcButton = _resolveComponent("NcButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card outer", { show: _ctx.show }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_XImg, {
          class: "img",
          src: _ctx.banner,
          "svg-tag": true
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.t('memories', 'A better photos experience awaits you')) + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Choose the root folder of your timeline to begin')), 1)
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.info) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_NcButton, {
              onClick: _ctx.finish,
              class: "button",
              variant: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Continue to Memories')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.info)
          ? (_openBlock(), _createBlock(_component_NcButton, {
              key: 0,
              onClick: _ctx.begin,
              class: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Choose again')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_NcButton, {
              key: 1,
              onClick: _ctx.begin,
              class: "button",
              variant: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Click here to start')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.t('memories', 'You can always change this later in settings')) + " ", 1),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'If you just installed Memories, visit the admin panel first.')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ]))
}